import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vModelText as _vModelText, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "fw-bold mb-3" };
const _hoisted_2 = { class: "rounded bg-white p-3" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6 col-12" };
const _hoisted_5 = { class: "form-check mb-3" };
const _hoisted_6 = { class: "form-floating mb-3" };
const _hoisted_7 = { class: "form-floating mb-3" };
const _hoisted_8 = { class: "mb-3" };
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, router, useForm } from '@inertiajs/vue3';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { Select, useConfirm } from 'primevue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Edit',
    props: {
        productCategory: {
            type: Object,
            required: true
        },
        productCategories: {
            type: Object,
            required: true
        }
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatCurrency, formatDate } = formatters();
        const props = __props;
        const confirm = useConfirm();
        const editProductCategoryForm = useForm({
            name: props.productCategory ? props.productCategory.name : null,
            nameEn: props.productCategory ? props.productCategory.nameEn : null,
            active: props.productCategory ? props.productCategory.active : false,
            parentUuid: props.productCategory && props.productCategory.parentUuid ? props.productCategory.parentUuid : null
        });
        function update() {
            if (props.productCategory == null) {
                return;
            }
            editProductCategoryForm.transform((data) => ({
                name: data.name,
                name_en: data.nameEn,
                active: data.active ? 1 : 0,
                parent_uuid: data.parentUuid
            }))
                .submit('put', route('admin.productCategories.update', props.productCategory.uuid), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        function remove() {
            confirm.require({
                message: 'Soll die Produkt-Kategorie wirklich gelöscht werden?',
                header: 'Produkt-Kategorie löschen?',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    if (props.productCategory == null) {
                        return;
                    }
                    router.delete(route('admin.productCategories.destroy', props.productCategory.uuid), {
                        preserveScroll: true,
                        onSuccess: page => {
                            showPageFlashMessage(page);
                        },
                        onError: errors => {
                            console.log(errors);
                            showErrorMessage(errors[0]);
                        }
                    });
                },
                reject: () => {
                    confirm.close();
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Produkt-Kategorie-Details" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _createElementVNode("h1", _hoisted_1, "Produkt-Kategorie: " + _toDisplayString(props.productCategory.name), 1),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("form", {
                                        onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event) => (update()), ["prevent"]))
                                    }, [
                                        _createElementVNode("div", _hoisted_5, [
                                            _withDirectives(_createElementVNode("input", {
                                                class: "form-check-input",
                                                type: "checkbox",
                                                value: "1",
                                                id: "active",
                                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(editProductCategoryForm).active) = $event))
                                            }, null, 512), [
                                                [_vModelCheckbox, _unref(editProductCategoryForm).active]
                                            ]),
                                            _cache[6] || (_cache[6] = _createElementVNode("label", {
                                                class: "form-check-label",
                                                for: "active"
                                            }, "Aktiv", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_unref(editProductCategoryForm).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(editProductCategoryForm).name]
                                            ]),
                                            _cache[7] || (_cache[7] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_7, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "nameEn",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(editProductCategoryForm).nameEn) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(editProductCategoryForm).nameEn]
                                            ]),
                                            _cache[8] || (_cache[8] = _createElementVNode("label", { for: "nameEn" }, "Name (en)", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_8, [
                                            _createVNode(_unref(Select), {
                                                class: "w-100",
                                                inputId: "parentCategory",
                                                modelValue: _unref(editProductCategoryForm).parentUuid,
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(editProductCategoryForm).parentUuid) = $event)),
                                                options: __props.productCategories,
                                                filter: "",
                                                optionLabel: "name",
                                                optionValue: "uuid",
                                                placeholder: "Übergeordnete Produktkategorie wählen (optional)"
                                            }, null, 8, ["modelValue", "options"])
                                        ]),
                                        _cache[9] || (_cache[9] = _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ], -1))
                                    ], 32),
                                    (props.productCategory.canRemove)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 0,
                                            class: "btn btn-danger d-inline-flex align-items-center mt-4",
                                            onClick: _cache[5] || (_cache[5] = ($event) => (remove()))
                                        }, [...(_cache[10] || (_cache[10] = [
                                                _createElementVNode("svg", {
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    width: "16",
                                                    height: "16",
                                                    fill: "currentColor",
                                                    class: "bi bi-x-circle",
                                                    viewBox: "0 0 16 16"
                                                }, [
                                                    _createElementVNode("path", { d: "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }),
                                                    _createElementVNode("path", { d: "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" })
                                                ], -1),
                                                _createElementVNode("span", { class: "ms-2" }, "Produkt-Kategorie löschen", -1)
                                            ]))]))
                                        : _createCommentVNode("", true)
                                ])
                            ])
                        ])
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
